const makeParamRoute = (route: string) => (params?: string | number) => params ? `${route}/${params}` : route;

export const ROUTES = {
  base: '/',
  dashboards: '/dashboards',
  feed: '/feed',
  markets: '/markets',
  marketStats: '/market-stats',
  companyList: '/company-list',
  specialSituations: '/special-situations',
  dataTools: '/data-tools',
  deals: '/deals',
  events: '/events',
  search: '/search',
  globalFeed: '/feed/global',
  myContent: '/my-content',
  user: '/user',
  article: makeParamRoute('/articles'),
  company: makeParamRoute('/companies'),
  municipal: makeParamRoute('/municipals'),
  analyst: makeParamRoute('/analysts'),
  notFound: '/404',
  userManagement: '/user-admin',
  logout: '/logout',
};

export const COMPANY_ROUTES = [ROUTES.company(), ROUTES.companyList];

export const MY_CONTENT_ROUTES = {
  articles: 'articles',
  watchlists: 'watchlists',
  searches: 'searches',
  covenants: 'covenants',
  managePreferences: 'preferences',
};

export const USER_ROUTES = {
  profile: 'profile',
  emailPreferences: 'email-preferences',
  complianceAndConsent: 'compliance-and-consent',
  onboarding: 'onboarding',
  login: 'login',
};

export const DATE_FORMATS = {
  MONTH_ABBR_DATE: 'dd MMM yy',
  YEAR_MONTH_DAY: 'yyyy-MM-dd',
  TIME: 'hh:mm a',
  DATE_TIME: 'dd MMM yy, hh:mm a',
  MONTH_YEAR: 'MMMM yyyy',
  MONTH_DAY_YEAR: 'MM/dd/yy',
};
